import Loader from "@components/Loader";
import { HOME } from "@constants/routes";
import UserContext from "@context/UserContext";
import logo from "@images/shared/logo.png";
import { ReactElement, useContext } from "react";
import { Redirect } from "react-router-dom";
import { TUserContext } from "types/Core/Authentication/userContext";
import LogInForm from "./components/LogInForm";
import styles from "./Login.module.scss";

const LogIn = (): ReactElement => {
  const { authenticated, isLoading, errorAuthMessage, HandleLogin } =
    useContext<TUserContext>(UserContext);

  if (authenticated) {
    return <Redirect to={HOME} />;
  }

  return (
    <div className={`${styles.login} account`}>
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">
              <img src={logo} alt="Backoffice logo" />
            </h3>
          </div>
          {isLoading ? (
            <Loader isInsideThing />
          ) : (
            <LogInForm onSubmit={HandleLogin} errorMessage={errorAuthMessage} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LogIn;
